module.exports = __webpack_public_path__ + "static/mr-concert-performance-05-b005194ac8fda76b121acf1b9ccfb3f6.jpg";